import React, { useState, useEffect } from "react";
import ReactApexChart from 'react-apexcharts';

const BarAndPieChart = (props) => {
    const { selectedYear } = props;

    const [barChartValues, setBarChartValues] = useState({
        data: ['0', '0', '0', '0'],
        categories: ["Product", "Software", "Operation", "Specific"]
    });

    const [pieChartValues, setPieChartValues] = useState({
        series: [5, 2, 7, 8],
        labels: ['Product', 'Software', 'Operation', 'Specific'],
        colors: ['#003CFF', '#00FFEE', '#146F9B', '#0090FF']
    });
    const [trainingInformation, setTrainingInformation] = useState({});

    const dateRangesEx = () => {
        // Iterate through the nested objects
        let product = 0;
        let software = 0;
        let operation = 0;
        let specific = 0;
        for (const year in trainingInformation) {
            for (const dateRange in trainingInformation[year]) {
                for (const individualDate in trainingInformation[year][dateRange]) {
                    const trainingMode = trainingInformation[year][dateRange][individualDate].trainingCourse;
                    // Check the trainingMode value and update counters
                    if (trainingMode === "Product") {
                        product += 1;
                    } else if (trainingMode === "Software") {
                        software += 1;
                    }
                    else if (trainingMode === "Operation") {
                        operation += 1;
                    }
                    else if(trainingMode === "Specific") {
                        specific += 1;
                    }
                }
            }
        }
        setBarChartValues(prevValues => ({
            ...prevValues,
            data: [product, software, operation, specific]
        }));
    }

    useEffect(() => {
        if (selectedYear) {
            const plannedEvents = localStorage.getItem("plannedEvent");
            setTrainingInformation(JSON.parse(plannedEvents));
        }
    }, [selectedYear]);

    useEffect(() => {
        if (Object.entries(trainingInformation).length > 0) {
            dateRangesEx()
        }
    }, [trainingInformation, selectedYear])

    const handleBarClick = (event, chartContext, config) => {
        const data = courseData[barChartValues.categories[config.dataPointIndex].toLowerCase()];
        setPieChartValues({ series: data.value, labels: data.courseName, colors: data.colors })
    }

    const coursesOptions = {
        series: [{
            data: barChartValues.data,
        },
        ],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                gradientToColors: ['#2D9CDB', 'rgba(45, 156, 219, 0.2)'],
                inverseColors: true,
                opacityFrom: 0.5,
                opacityTo: 1,
                stops: [0, 100],
            },
        },
        chart: {
            height: 150,
            type: 'bar',
            events: {
                dataPointSelection: handleBarClick
            },
            toolbar: {
                show: false,
            },
            //   sparkline: {
            //     enabled: true
            //  },
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            bar: {
                borderRadius: 10,
                columnWidth: '45%',
                dataLabels: {
                    position: 'top', // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                fontSize: '12px',
                colors: ["#fff"]
            }
        },
        xaxis: {
            categories: barChartValues.categories,
            position: 'bottom',
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: '#fff',
                },
            },
            tooltip: {
                enabled: false,
            },
            crosshairs: {
                show: false,
            },
        },
        yaxis: {
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false,
            },
            labels: {
                show: false,
            }
        },
        title: {
            text: 'Course Taken',
            floating: true,
            offsetY: 330,
            align: 'left',
            style: {
                color: '#fff'
            }
        }
    }

    const legendFormatter = (seriesName, opts) => {
        const labelName = opts.w.config.label[opts.seriesIndex];
        const words = labelName.split(' ');
        let lines = [];
        let currentLine = '';
        for (let word of words) {
            if ((currentLine + word).length <= 12) {
                currentLine += word + ' '
            }
            else {
                lines.push(currentLine.trim());
                currentLine = word + '';
            }
        }
        lines.push(currentLine.trim());
        return lines.join('<br>')
        // return labelName.length > 10? labelName.substring(0,10) : labelName;
    }

    const pieChartOptions = {
        series: pieChartValues.series,
        chart: {
            height: 400,
            width: 400,
            type: 'donut',
        },
        colors: pieChartValues.colors,
        label: pieChartValues.labels,
        tooltip: {
            enabled: false,
        },
        stroke: {
            colors: ['#2a2e32'],
            lineCap: 'round',
        },
        plotOptions: {
            pie: {
                donut: {
                    labels: {
                        show: true,
                        formatter: function (seriesName, opts) {
                            return [opts.w.config.label[opts.seriesIndex]]
                        },
                        name: {
                            fontSize: '10px',
                        },
                        value: {
                            fontSize: '10px',
                            color: '#fff',
                        },
                    }
                }
            }
        },
        legend: {
            show: true,
            position: 'right',
            formatter: function (seriesName, opts) {
                return legendFormatter(seriesName, opts)
            },
            labels: {
                colors: '#fff',
            },
            fontSize: '8px',
        },
        dataLabels: {
            enabled: true,
            // Set to true to show data labels
            style: {
                fontSize: '10px',
            },
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex]
            },
            total: {
                show: true,
                label: 'Total',
                color: 'white',
                formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                },
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    };

    return (
        <>
            <div className="pr-12 pb-12">
                <ReactApexChart options={coursesOptions} series={coursesOptions.series} type="bar" height={200} />
            </div>
            <div className="pr-12 pb-12">
                <ReactApexChart options={pieChartOptions} series={pieChartOptions.series} type="donut" height={400} width={300} />
            </div>
        </>
    )
}

export default BarAndPieChart;